import { render, staticRenderFns } from "./ConsultationTransferModal.vue?vue&type=template&id=83d371bc&scoped=true"
import script from "./ConsultationTransferModal.vue?vue&type=script&lang=js"
export * from "./ConsultationTransferModal.vue?vue&type=script&lang=js"
import style0 from "./ConsultationTransferModal.vue?vue&type=style&index=0&id=83d371bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d371bc",
  null
  
)

export default component.exports